import { HTTP } from "@/api";
import WebSocketService from "@/socket";

export default {
  login({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      const validate = loginDataValidate(data);
      if (validate !== true) return reject(validate);
      HTTP.post("/v2/auth/login", data)
        .then((res) => {
          let data = res.data;
          if (data && data.success) {
            commit("login", {
              user: data.user,
            });
            commit("SET_MATCH_GENERAL_DATA", []);
            dispatch("fetchFavorites");
            WebSocketService.process({
              action: "auth",
              data: {
                userId: data.user._id,
                token: data.user.accessToken,
              },
            });
            resolve();
          } else reject(data.message);
        })
        .catch(reject);
    });
  },
  logout({ commit, dispatch }) {
    WebSocketService.process({
      action: "no-auth",
      data: {},
    });
    commit("logout");
    dispatch("fetchFavorites"); // сброс к гостевому localStorage
    try {
      // подсказка для hero: после выхода состояние другое (см. Hero.vue)
      localStorage.removeItem("hero-try-free");
    } catch {
      // storage недоступен
    }
    return new Promise((resolve, reject) => {
      HTTP.get("/v2/auth/logout")
        .then((res) => {
          let data = res.data;
          if (data && data.success) {
            resolve();
          } else reject(data.message);
        })
        .catch(reject);
    });
  },
  register(_, payload) {
    return new Promise((resolve, reject) => {
      const validate = loginDataValidate(payload);
      if (validate !== true) return reject(validate);
      HTTP.post("/score/auth/register", payload)
        .then((res) => {
          if (res.data) {
            const { data } = res;

            if (!data.success) return reject(data.message);

            resolve("Registration successful! You can login now"); // !FIX: translate
          }
        })
        .catch(reject);
    });
  },
  forget(store, { email }) {
    return new Promise((resolve, reject) => {
      const validate = loginDataValidate({ email });
      if (validate !== true) {
        reject(validate);
        return;
      }
      HTTP.post("/score/auth/forgot", { email })
        .then((res) => {
          if (res.data.success) {
            resolve("Please, check your email");
          } else {
            reject(res.data.message);
          }
        })
        .catch(reject);
    });
  },
  changePassword(store, { passwordOld, passwordNew }) {
    return new Promise((resolve, reject) => {
      const validate = loginDataValidate({ password: passwordNew });
      if (validate !== true) {
        reject(validate);
        return;
      }
      HTTP.post("/score/auth/change-password", {
        email: store.state.user.email,
        passwordOld,
        passwordNew,
      })
        .then((res) => {
          if (res.data.success) {
            resolve(res.data.message);
          } else {
            reject(res.data.message);
          }
        })
        .catch(reject);
    });
  },
  checkCode(store, code) {
    console.log(code);
    return new Promise((resolve, reject) => {
      HTTP.post("/v2/auth/check-email-code", { code })
        .then((res) => {
          let data = res.data;
          if (data && data.success) {
            store.dispatch("session").then(resolve).catch(reject);
          } else reject(data.message);
        })
        .catch(reject);
    });
  },

  sendCode(store) {
    return new Promise((resolve, reject) => {
      HTTP.get("/v2/auth/send-email-code")
        .then((res) => {
          if (res.data.success) {
            resolve("Please, check your email");
          } else {
            reject(res.data.message);
          }
        })
        .catch(reject);
    });
  },

  session({ commit, dispatch }) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await HTTP.get("/v2/auth/init");
        let data = res.data;
        if (data && data.success) {
          commit("login", {
            user: data.user,
          });
          WebSocketService.process({
            action: "auth",
            data: {
              userId: data.user._id,
              token: data.user.accessToken,
            },
          });
          dispatch("fetchAds");
          dispatch("fetchFavorites");
          resolve(true);
        } else {
          dispatch("fetchGuestPermissions");
          dispatch("fetchAds");
          dispatch("fetchFavorites");
          reject(data.message);
        }
      } catch (e) {
        console.log(e);
        commit("login", {
          user: false,
        });
        dispatch("fetchGuestPermissions");
        dispatch("fetchAds");
        dispatch("fetchFavorites");
      }
    });
  },
  fetchGuestPermissions({ commit }) {
    return HTTP.get("/v2/permissions/guest")
      .then((res) => {
        if (res.data && res.data.success) {
          commit("setGuestPermissions", res.data.permissions);
        }
      })
      .catch(() => {});
  },
  deleteDevice({ commit, dispatch }, id) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await HTTP.delete("/v2/auth/device/" + id);

        let data = res.data;

        if (data && data.success) {
          commit("devices", {
            devices: data.devices,
          });
          resolve(true);
        } else {
          reject(data.message);
        }
      } catch (e) {
        if (e.response && e.response.status === 403) {
          const { time } = e.response.data;
          const hours = Math.floor(time / 60);
          const minutes = time % 60;
          reject(
            `Deletion not allowed. Available after: ${hours} hours ${minutes} minutes`,
          );
        } else {
          console.error("Error:", e);
          reject("An error occurred.");
        }
      }
    });
  },

  updateProfile({ dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      const validate = loginDataValidate(data);
      if (validate !== true) reject(validate);
      HTTP.post("/auth/profile", { ...data, id: state.user.id })
        .then((res) => {
          let data = res.data;
          if (data && data.success) {
            window.$cookies.set(
              "session",
              {
                user: data.user,
                session: state.session,
              },
              state.session.expiresIn,
            );
            dispatch("session").then(resolve).catch(reject);
          } else reject(data);
        })
        .catch(reject);
    });
  },
  toggleTheme({ commit, state }) {
    commit("setTheme", !state.isDarkTheme);
  },
  initializeTheme({ commit }) {
    commit("setTheme", localStorage.getItem("user-theme") === "dark-theme");
  },
};

function loginDataValidate(data) {
  if (data.hasOwnProperty("email")) {
    if (!data.email) return "E-mail not specified";
    // eslint-disable-next-line no-useless-escape
    let pattern =
      /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!pattern.test(data.email)) return "Wrong e-mail format";
  }
  if (data.hasOwnProperty("username")) {
    if (!data.username) return "Username not specified";
  }
  if (data.hasOwnProperty("password")) {
    if (!data.password) return "Password not specified";
    if (
      data.password.length < 8 ||
      !/[!@#$%^&*(),.?":{}|<>]/.test(data.password)
    ) {
      return data.password.length < 8
        ? "Password must be at least 8 characters long and contain at least one special character"
        : " Password must be contain at least one special character";
    }
  }
  return true;
}
